export default __webpack_public_path__ + "static/media/iconadd.cbab4bb6.svg";